import { createSelector } from '@reduxjs/toolkit';

import { specialPromosBlocksSelector } from './specialPromosBlocksSelector';

export const developerAwardsSelector = createSelector(specialPromosBlocksSelector, state => state.developerAwards);
